export default __webpack_public_path__ + "static/2-a3f8f6aaa2f7da6c4c0951c32db0192d.png";